import { IconButton, withStyles } from '@material-ui/core';

export const StyledIconButton = withStyles(({ spacing }) => ({
  root: {
    width: 46,
    minWidth: 46,
    height: 46,
    marginRight: spacing(1),
  },
}))(IconButton);
